import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Icon from "@material-ui/core/Icon/Icon";
import InputBase from "@material-ui/core/InputBase/InputBase";
import {withStyles} from "@material-ui/core/styles/index";

class SearchField extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            searchQuery: props.value || '',
        };
    }

    handleChange(e) {
        this.setState({
            searchQuery: e.target.value
        });
        console.log(e.target.value)
        if ( this.props.searchByTyping ) {
            this.handleDoSearch(e, e.target.value);
        }
    }

    handleDoSearch(e, searchQuery) {
        e.preventDefault();
        this.props.doSearch(
            searchQuery
        );
    }

    render() {
        let classes = this.props.classes;
        return (
            <div className={classes.search}>
                <form onSubmit={this.handleDoSearch.bind(this)}>
                    <div className={classes.searchIcon}>
                        <Icon>search</Icon>
                    </div>
                    <TextField
                        type="text"
                        name="search"
                        autoComplete="false"
                        className={classes.inputInput}
                        placeholder={this.props.label}
                        value={this.state.searchQuery}
                        onChange={this.handleChange.bind(this)}
                        title={this.props.title}
                    />
                </form>
            </div>
        );
    }
}

SearchField.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
    doSearch: PropTypes.func.isRequired,
    searchByTyping: PropTypes.bool,
};


const styles = theme => ({
    search: {
        position: 'relative',
        color: theme.colors.lightGreyBlue,
        // float: "right",
    },
    searchIcon: {
        width: theme.spacing.unit * 2,
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: theme.colors.lightGreyBlue,
    },
    inputInput: {
        width: '100%',
        paddingTop: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 3,
        transition: theme.transitions.create('width'),
    },
});

export default withStyles(styles)(SearchField);



// WEBPACK FOOTER //
// ./resources/assets/js/components/Media/SearchField.js